import axios from 'axios'
export default class BlogService {
  static getBlogs(token) {
    return new Promise((fulfill, reject) => {
      axios.get(`/blogs/blogs`,{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static getBlog(id,token) {
    return new Promise((fulfill, reject) => {
      axios.get(`/blogs/blogs/${id}`,{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static getLatestBlog(token) {
    return new Promise((fulfill, reject) => {
      axios.get(`/blogs/blogs-latest`,{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }
  static getCategories(token) {
    return new Promise((fulfill, reject) => {
      axios.get(`/blogs/categories`, {headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static removeBlog(id,token) {
    return new Promise((fulfill, reject) => {
      axios.delete(`/blogs/blogs/${id}` ,{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static updateBlog(blog,token) {
    return new Promise((fulfill, reject) => {
      axios.put(`/blogs/blogs/${blog.id}` ,{
        id: blog.id,
        title: blog.title,
        body: blog.body,
        category: blog.category,
        author: blog.author,
        publish_status: blog.publishStatus,
      },{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static publishBlog(blog, token, publish_status) {
    return new Promise((fulfill, reject) => {
      axios.patch(`/blogs/blogs/${blog.id}/publish` ,{
          id: blog.id,
          title: blog.title,
          body: blog.body,
          category: blog.category,
          author: blog.author,
          publish_status: publish_status,
          published_date: new Date()
        },{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static addBlog(blog,token) {
    return new Promise((fulfill, reject) => {
      axios.post(`/blogs/blogs`, {
        title: blog.title,
        body: blog.body,
        category: blog.category,
        author: blog.author,
      },{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static addComment(id, comment, token){
    return new Promise((fulfill, reject) => {
      axios.post(`/blogs/blog/${id}/comments`, {
        comment:comment
      },{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static updateComment(comment, blogId, token){
    return new Promise((fulfill, reject) => {
      axios.put(`/blogs/comment/${comment.id}`, {
        comment:comment.comment,
        id:comment.id,
        blogId:blogId
      },{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }

  static removeComment(comment, token){
    return new Promise((fulfill, reject) => {
      axios.delete(`/blogs/comment/${comment.id}`,{headers: {"Authorization": `Bearer ${token}`}}).then(response => {
        fulfill(response)
      }).catch(error=>{
        reject(error)
      })
    }).catch(error => {
      reject(error)
    })
  }
}